/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type InspectionFormResponse,
    InspectionFormResponseFromJSON,
    InspectionFormResponseToJSON,
} from '../models/InspectionFormResponse';

export interface GenerateBatchRequest {
    /**
     * 
     */
    requestBody: Array<string>;
}

export interface GenerateFormRequest {
    /**
     * Schedule ID
     */
    id: string;
}

/**
 * 
 */
export class FormGenerationApi extends runtime.BaseAPI {

    /**
     * Creates request options for generateBatch without sending the request
     */
    async generateBatchRequestOpts(requestParameters: GenerateBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling generateBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/schedules/generate-batch`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Triggers form generation in batch for multiple schedules. Schedules with no published version are skipped. Errors on individual schedules do not fail the batch.
     * Generate inspection forms for multiple schedules
     */
    async generateBatchRaw(requestParameters: GenerateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.generateBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Triggers form generation in batch for multiple schedules. Schedules with no published version are skipped. Errors on individual schedules do not fail the batch.
     * Generate inspection forms for multiple schedules
     */
    async generateBatch(requestParameters: GenerateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.generateBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateForm without sending the request
     */
    async generateFormRequestOpts(requestParameters: GenerateFormRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling generateForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/{id}/generate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Triggers form generation for the specified schedule. Resolves the template\'s active (latest PUBLISHED) version, creates a snapshot, and produces a PENDING form instance. If no published version exists, returns 204 with no body (generation skipped). Previous PENDING forms for the same schedule are marked as OVERDUE.
     * Generate an inspection form for a schedule
     */
    async generateFormRaw(requestParameters: GenerateFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.generateFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Triggers form generation for the specified schedule. Resolves the template\'s active (latest PUBLISHED) version, creates a snapshot, and produces a PENDING form instance. If no published version exists, returns 204 with no body (generation skipped). Previous PENDING forms for the same schedule are marked as OVERDUE.
     * Generate an inspection form for a schedule
     */
    async generateForm(requestParameters: GenerateFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.generateFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for runDue without sending the request
     */
    async runDueRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/schedules/run-due`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Runs on-the-fly generation for every active schedule currently due (nextGenerationAt <= now, within date range). Idempotent per schedule (skips a schedule that already has an open PENDING form). Intended for manual admin kicks or a coarse external trigger (e.g. EventBridge). Also invoked automatically when the admin Tasks list is read.
     * Generate forms for all due schedules now (on-the-fly / manual)
     */
    async runDueRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.runDueRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Runs on-the-fly generation for every active schedule currently due (nextGenerationAt <= now, within date range). Idempotent per schedule (skips a schedule that already has an open PENDING form). Intended for manual admin kicks or a coarse external trigger (e.g. EventBridge). Also invoked automatically when the admin Tasks list is read.
     * Generate forms for all due schedules now (on-the-fly / manual)
     */
    async runDue(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.runDueRaw(initOverrides);
        return await response.value();
    }

}
